import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

import { snDetailExpand, snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { FsWhoosterHistoryModel } from '@lib/whooster';
import { SnTableBaseComponent } from 'libs/core/src/lib/components/table-base.component';

@Component({
  selector: 'sn-whooster-history-table',
  templateUrl: './whooster-history-table.component.html',
  styleUrls: ['./whooster-history-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut, snDetailExpand],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FsWhoosterHistoryTableComponent extends SnTableBaseComponent<FsWhoosterHistoryModel> {
  @Output()
  public readonly searchParam = new EventEmitter<any>();

  constructor() {
    super();
  }

  public trackBy(index: number, item: FsWhoosterHistoryModel): string {
    return item.uuid;
  }

  public whoosterSearch(item: any): void {
    this.searchParam.emit(item);
  }
}
